import { BASE_URL } from "../constants";
import FetchUtils from "../utils/fetch";

class ReportService {
    static async ReportTapping(start_date: string, end_date: string): Promise<{
        id_card: number,
        karyawan: string,
        vendor: string,
        lokasi: string,
        shift: number,
        tipe: string,
        datetime_in: string,
        porsi: number,
    }[]> {
        let resp = await FetchUtils.fetchAuth(`${BASE_URL}/api/v1/report/tapping?start_date=${start_date}&end_date=${end_date}`);
        if (resp.status != 200) { throw resp.message }

        const data = [];
        for (let i = 0; i < resp.data.length; i++) {
            data.push({
                id_card: resp.data[i].IDCard,
                karyawan: resp.data[i].Karyawan,
                vendor: resp.data[i].Vendor,
                lokasi: resp.data[i].Lokasi,
                shift: resp.data[i].Shift,
                tipe: resp.data[i].Tipe,
                datetime_in: resp.data[i].DatetimeIn,
                porsi: resp.data[i].Porsi
            })
        }

        return data;
    }

    static async ReportDropoff(start_date?: string, end_date?: string): Promise<{
        id: number,
        requestor: string,
        penerima: string,
        vendor: string,
        lokasi: string,
        lokasi_dropoff: string,
        shift: number,
        jumlah_porsi: string,
        datetime_in: string,
    }[]> {
        let resp = await FetchUtils.fetchAuth(`${BASE_URL}/api/v1/report/dropoff?start_date=${start_date}&end_date=${end_date}`);
        if (resp.status != 200) { throw resp.message }

        const data = [];
        for (let i = 0; i < resp.data.length; i++) {
            data.push({
                id: resp.data[i].ID,
                requestor: resp.data[i].Requestor,
                penerima: resp.data[i].Penerima,
                vendor: resp.data[i].Vendor,
                lokasi: resp.data[i].Lokasi,
                lokasi_dropoff: resp.data[i].LokasiDropoff,
                shift: resp.data[i].Shift,
                jumlah_porsi: resp.data[i].JumlahPorsi,
                datetime_in: resp.data[i].DatetimeIn,
            })
        }

        return data;
    }

    static async ReportLongshift(start_date: string, end_date: string): Promise<{
        id_card: number,
        karyawan: string,
        shift: string
        tapping: string,
        tanggal: string
    }[]> {
        let resp = await FetchUtils.fetchAuth(`${BASE_URL}/api/v1/report/longshift?start_date=${start_date}&end_date=${end_date}`);
        if (resp.status != 200) { throw resp.message }

        const data = [];
        for (const val of resp.data) {
            data.push({
                id_card: val.IDCard,
                karyawan: val.Karyawan,
                jumlah_tapping: val.JumlahTapping,
                shift: val.Shift,
                tapping: val.Tapping,
                tanggal: val.Tanggal,
            })
        }

        return data;
    }
}

export { ReportService };